const GAME_STATUSES = {
    PRISTINE: "Připravena",
    RUNNING: "Spuštěna",
    STOPPED: "Zastavena",
    ADMIN_PAUSED: "Pozastavena",
    ENDED: "Ukončena",
    END_MONTH_PAUSED: "Pozastavena na konci měsíce"
};
export default GAME_STATUSES;